// This file is auto-generated by @hey-api/openapi-ts
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var extraPrefixesMap = {
    $body_: "body",
    $headers_: "headers",
    $path_: "path",
    $query_: "query",
};
var extraPrefixes = Object.entries(extraPrefixesMap);
var buildKeyMap = function (fields, map) {
    var e_1, _a;
    if (!map) {
        map = new Map();
    }
    try {
        for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
            var config = fields_1_1.value;
            if ("in" in config) {
                if (config.key) {
                    map.set(config.key, {
                        in: config.in,
                        map: config.map,
                    });
                }
            }
            else if ("key" in config) {
                map.set(config.key, {
                    map: config.map,
                });
            }
            else if (config.args) {
                buildKeyMap(config.args, map);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return map;
};
var stripEmptySlots = function (params) {
    var e_2, _a;
    try {
        for (var _b = __values(Object.entries(params)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), slot = _d[0], value = _d[1];
            if (value && typeof value === "object" && !Object.keys(value).length) {
                delete params[slot];
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
export var buildClientParams = function (args, fields) {
    var e_3, _a, e_4, _b;
    var params = {
        body: {},
        headers: {},
        path: {},
        query: {},
    };
    var map = buildKeyMap(fields);
    var config;
    try {
        for (var _c = __values(args.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2), index = _e[0], arg = _e[1];
            if (fields[index]) {
                config = fields[index];
            }
            if (!config) {
                continue;
            }
            if ("in" in config) {
                if (config.key) {
                    var field = map.get(config.key);
                    var name = field.map || config.key;
                    if (field.in) {
                        params[field.in][name] = arg;
                    }
                }
                else {
                    params.body = arg;
                }
            }
            else {
                var _loop_1 = function (key, value) {
                    var e_5, _j;
                    var field = map.get(key);
                    if (field) {
                        if (field.in) {
                            var name = field.map || key;
                            params[field.in][name] = value;
                        }
                        else {
                            params[field.map] = value;
                        }
                    }
                    else {
                        var extra = extraPrefixes.find(function (_a) {
                            var _b = __read(_a, 1), prefix = _b[0];
                            return key.startsWith(prefix);
                        });
                        if (extra) {
                            var _k = __read(extra, 2), prefix = _k[0], slot = _k[1];
                            params[slot][key.slice(prefix.length)] = value;
                        }
                        else if ("allowExtra" in config && config.allowExtra) {
                            try {
                                for (var _l = (e_5 = void 0, __values(Object.entries(config.allowExtra))), _m = _l.next(); !_m.done; _m = _l.next()) {
                                    var _o = __read(_m.value, 2), slot = _o[0], allowed = _o[1];
                                    if (allowed) {
                                        params[slot][key] = value;
                                        break;
                                    }
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (_m && !_m.done && (_j = _l.return)) _j.call(_l);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        }
                    }
                };
                try {
                    for (var _f = (e_4 = void 0, __values(Object.entries(arg !== null && arg !== void 0 ? arg : {}))), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var _h = __read(_g.value, 2), key = _h[0], value = _h[1];
                        _loop_1(key, value);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_3) throw e_3.error; }
    }
    stripEmptySlots(params);
    return params;
};
